<template>
  <footer class="footer bg text-white">
    <div class="container-fluid py-4">
      <div class="row align-items-start">
        <!-- Logo Section -->
        <div class="col-md-3 mb-3 mb-md-0 text-center text-md-left">
          <div class="footer-logo">
            <img src="../assets/footer/RTB.png" alt="RTB Logo" />
          </div>
        </div>

        <!-- Navigation Links -->
        <div class="col-md-2 mb-2 mb-md-0">
          <div class="footer-links">
            <a href="http://www.rtb.gov.bn/Theme/Home.aspx" target="_blank"
              >Corporate Information</a
            >
            <router-link :to="'/privacy'" target="_blank"
              >Privacy Policy</router-link
            >
            <router-link :to="'/disclaimer'" target="_blank"
              >Disclaimer</router-link
            >
            <router-link :to="'/terms'" target="_blank"
              >Terms of Use</router-link
            >
          </div>
        </div>

        <!-- Social Media Section -->
        <div class="col-md-3 mb-2 mb-md-0">
          <div class="social-section">
            <p class="follow-text">Follow Us</p>
            <div class="social-icons">
              <a
                href="https://www.facebook.com/rtb.bn"
                target="_blank"
                class="social-link"
              >
                <img src="../assets/icon/Icon-Facebook.svg" alt="Facebook" />
              </a>
              <a
                href="https://twitter.com/rtb_bn?lang=en"
                target="_blank"
                class="social-link"
              >
                <img src="../assets/icon/Icon-twitter.svg" alt="Twitter" />
              </a>
              <a
                href="https://www.instagram.com/rtbgo.bn/?hl=en"
                target="_blank"
                class="social-link"
              >
                <img src="../assets/icon/Icon-insta.svg" alt="Instagram" />
              </a>
              <a
                href="https://www.youtube.com/rtbbn"
                target="_blank"
                class="social-link"
              >
                <img src="../assets/icon/Icon-youtube.svg" alt="YouTube" />
              </a>
            </div>
          </div>
        </div>

        <!-- App Download Section -->
        <div class="col-md-4 mb-2 mb-md-0">
          <div class="download-section">
            <div class="app-links">
              <a
                href="https://apps.apple.com/my/app/rtbgo/id1534587085"
                target="_blank"
                class="app-store"
              >
                <img src="../assets/icon/ios.png" alt="App Store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.rtbgo.bn"
                target="_blank"
                class="app-store"
              >
                <img src="../assets/icon/android.png" alt="Google Play" />
              </a>
            </div>
          </div>
          <!-- Copyright Section -->
          <div class="w-full mt-3">
            <div class="col-12 text-center text-md-left px-0">
              <div class="copyright">
                <p>
                  {{ currentYear }} © Copyright Radio Television Brunei. All
                  Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <formfeed ref="formfeed"></formfeed>

    <!-- Go to top button -->
    <div
      @click="goToTop"
      class="float-to-top"
      :style="{ bottom: lastScrollPosition }"
      v-if="displayToTop"
    >
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </div>
  </footer>
</template>

<script>
/* eslint-disable */
import formfeed from "../components/popup/form";
export default {
  data: function() {
    return {
      showModal: false,
      lastScrollPosition: 0,
      displayToTop: false,
      currentYear: new Date().getFullYear(),
    };
  },
  components: { formfeed },
  methods: {
    openModal() {
      this.$refs.formfeed.show();
    },
    homePage() {
      if (this.$route.path == "/" || this.$route.path == "/home") {
        return true;
      } else {
        return false;
      }
    },
    goToTop() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
    },
    onScroll(event) {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      const totalHeight = document.body.offsetHeight - 1000;

      if (totalHeight <= currentScrollPosition) {
        this.lastScrollPosition = "102px";
      } else {
        this.lastScrollPosition = "10px";
      }

      if (currentScrollPosition > 150) {
        this.displayToTop = true;
      } else {
        this.displayToTop = false;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll, true);
  },
};
</script>

<style scoped>
.footer {
  background: #191919;
  position: relative;
  width: 100%;
  padding: 20px 0;
  border-top: 5px solid #fab913;
}

.footer-logo img {
  width: 150px;
  max-width: 100%;
}

.footer-links {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.footer-links a {
  color: #ffffff;
  text-decoration: none;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.footer-links a:hover {
  color: #fab900;
}

.social-section,
.download-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.follow-text,
.download-text {
  width: 100%;
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 10px;
  text-align: left;
  font-family: "Poppins", sans-serif !important;
}

.social-icons,
.app-links {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.social-link {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
}

.social-link img {
  height: 12px;
  width: auto;
}

.app-store {
  max-width: 120px;
  margin: 0 5px;
}

.app-store img {
  width: 100%;
}

.copyright {
  margin-top: 10px;
  color: #ffffff;
  font-family: "Poppins", sans-serif !important;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
}

.float-to-top {
  position: fixed;
  right: 21px;
  bottom: 20px;
  background-color: #fbcb43;
  color: black;
  border-radius: 50%;
  text-align: center;
  z-index: 111111111;
  cursor: pointer;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.float-to-top i {
  font-size: 1.5rem;
}

@media (max-width: 767px) {
  .social-icons,
  .app-links {
    justify-content: center;
    margin-top: 4px;
  }

  .footer-logo,
  .footer-links,
  .social-section,
  .download-section {
    text-align: center;
    margin-bottom: 20px;
    font-family: "Poppins", sans-serif !important;
  }

  .footer-links {
    align-items: center;
  }

  .social-link {
    width: 35px;
    height: 35px;
    margin: 0 3px;
  }

  .social-link img {
    height: 15px;
  }

  .app-store {
    max-width: 100px;
  }

  .follow-text,
  .download-text {
    font-size: 14px;
    text-align: center;
  }
}

@media (max-width: 575px) {
  .social-section,
  .download-section {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .follow-text,
  .download-text {
    margin-right: 10px;
    margin-bottom: 0;
  }
}
</style>
